import {useDispatch, useSelector} from "react-redux";
import {appConfigSelector, rxToggleExpiredModal} from "../slices/appSlice";
import moment from "moment";
import {useCallback} from "react";

const useProject = () => {
  const dispatch = useDispatch();

  const {expirationDate} = useSelector(appConfigSelector);

  const expired = moment(expirationDate).isBefore(moment());
  const expiredSoon = moment(expirationDate).isBefore(moment().add(15, "days"));

  const runWithExpiration = useCallback(func => e => {
    if (moment(expirationDate).isBefore(moment())) {
      if (e) {
        e.preventDefault();
      }

      dispatch(rxToggleExpiredModal());

      return Promise.resolve();
    }

    return func(e);
  }, [expirationDate , dispatch]);

  return {expired, expiredSoon, runWithExpiration, expirationDate}
};

export default useProject;
